const INVALID_COLOR = 0xe24b4a;

export { INVALID_COLOR };
